import { ITableService } from 'src/app/common/interfaces/table/table-service.interface';
import { IRespondentReconTransactions } from '../../interfaces/reconciliation/respondent/respondent-recon-transaction.interface';

export abstract class AbstractRtpRespondentReconService extends ITableService {
  abstract getReconciliationDetails(
    cycleDate: string,
    reconWindowId: number
  ): Promise<IRespondentReconTransactions[] | undefined>;
}
